// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"Uploader_dropzone__3ipmE","active":"Uploader_active__1a-X4"};